exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".admin-sites .sites{display:block;padding:15pt;background-color:#fff}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/admin/Sites/Sites.vue"],"names":[],"mappings":"AACA,oBACE,cAAe,AACf,aAAc,AACd,qBAAwB,CACzB","file":"Sites.vue","sourcesContent":["\n.admin-sites .sites {\n  display: block;\n  padding: 15pt;\n  background-color: white;\n}\n\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-72ca6d57","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/Sites/Sites.vue
// module id = 987
// module chunks = 10